export default __webpack_public_path__ + "static/media/openpayment.d415ce2f.yaml";